import { createAction, createSlice } from '@reduxjs/toolkit';
import { AssetBalanceStatistics, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AssetBalanceStatsState {
    [key: string]: AssetBalanceStatistics;
}

const initialState: AssetBalanceStatsState = {};

const initialLoad = createAction<{ assetBalanceStats: AssetBalanceStatsState }>('InitialLoad');
const assetBalanceStatistics = createAction<AssetBalanceStatistics>(CoreMsgTypes.AssetBalanceStatistics);
const assetBalanceStatsSlice = createSlice({
    name: 'assetBalanceStats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(initialLoad, (state, action) => {
            return {
                ...state,
                ...action.payload.assetBalanceStats
            };
        })
            .addCase(assetBalanceStatistics, (state, action) => {
                state[action.payload.AssetId] = {
                    ...state[action.payload.AssetId],
                    ...action.payload
                };
            })
            .addDefaultCase(state => state);
    }
});

export default assetBalanceStatsSlice.reducer;